module.exports = __webpack_public_path__ + "img/headerLogo.f75912d2.png";